/* eslint-disable max-len */
import { AvatarCustom, CentralLoadingIndicator, DuplicateAccountAlertCard } from "../../../components";
import React, { useEffect } from "react";

import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import HomeHospitalIcon from "../../../components/Icons/HomeHospitalIcon";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
import { PAGES_PATH } from "../../../navigation/params";
import UserBillingIcon from "../../../components/Icons/UserBillingIcon";
import UserEditIcon from "../../../components/Icons/UserEditIcon";
import UserMailIcon from "../../../components/Icons/UserMailIcon";
import UserPhoneIcon from "../../../components/Icons/UserPhoneIcon";
import UserProfileMenu from "../../../components/UserProfileMenu/UserProfileMenu";
import { useModal } from "../../../context/ModalContext";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import PastPetIcon from "../../../components/Icons/PastPetIcon";
import { usePastPetsList } from "../../../services/past-pets/past-pets.service";

const formatContact = (contact: string) => {
  if (contact && contact.length === 10) {
    return `${contact.slice(0, 3)}-${contact.slice(3, 6)}-${contact.slice(6)}`;
  }

  return contact;
};

const UserDetailsContainer = () => {
  const { user, loading } = useUserDetail();
  const { openModal } = useModal();
  const {
    getPastPets,
    pastPetsList,
    loading: pastPetsLoading,
  } = usePastPetsList();

  const handleDeleteAccount = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    openModal(MODALS.USER_DELETE);
  };
  const handleLogOut = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    openModal(MODALS.LOGOUT);
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.MY_ACCOUNT, {});
    getPastPets();
  }, []);

  if (loading || pastPetsLoading) {
    return <CentralLoadingIndicator />;
  }

  return (
    <div className="flex flex-col justify-between items-center gap-5 py-3 h-full">
      <div className="w-full max-w-[528px]">
        <div className="flex flex-col items-center mb-2">
          <AvatarCustom
            image={user?.image}
            name={user?.firstName}
            width={100}
            height={100}
            sx={{ mb: 3 }}
            avatarStyleToggle={true}
          />
          <div className="flex flex-col gap-3 items-center cursor-default">
            <div className="grenette-pro text-2xl capitalize">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="flex flex-col gap-1.5 items-center">
              {user && user.phone && user.phone !== "" && (
                <div className="text-sm flex gap-1 items-center">
                  <UserPhoneIcon />
                  {formatContact(user.phone)}
                </div>
              )}
              <div className="text-sm flex gap-1 items-center">
                <UserMailIcon />
                {user?.email}
              </div>
            </div>
          </div>
        </div>
        {user && user.isDuplicateAccount && (
          <div className="px-4 my-2">
            <DuplicateAccountAlertCard />
          </div>
        )}
        <div className="flex flex-col gap-2 px-4">
          <UserProfileMenu
            icon={<UserEditIcon />}
            text={"Edit Profile"}
            navigateTo={PAGES_PATH.EDIT_PROFILE}
          />
          <UserProfileMenu
            icon={<UserBillingIcon />}
            text={"Plan & Billing"}
            navigateTo={PAGES_PATH.USER_BILLING}
          />
          <UserProfileMenu
            icon={<HomeHospitalIcon />}
            text={"Change Home Hospital"}
            navigateTo={PAGES_PATH.CHANGE_HOSPITAL}
          />
          {pastPetsList && pastPetsList.length > 0 && (
            <UserProfileMenu
              icon={<PastPetIcon />}
              text={"Past Pets"}
              navigateTo={PAGES_PATH.PAST_PETS}
            />
          )}
        </div>
      </div>
      <div className="flex flex-col items-center w-full max-w-[528px] pb-4">
        <GvSecondaryButton
          type="button"
          className="text-sm !text-gray-1 font-semibold !my-0"
          onClick={handleDeleteAccount}
        >
          Delete Account
        </GvSecondaryButton>
        <button
          type="button"
          className="border border-taupe-2 bg-gray-3 w-full py-2 px-8 rounded-[6.25rem] text-sm
        font-semibold"
          onClick={handleLogOut}
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default UserDetailsContainer;
